<template>
	<div class="content">
		<ProductEditor :id="getId()" />
	</div>
</template>

<script>
import ProductEditor from '@/components/ProductEditor.vue'
import EventViewer from '@/components/EventViewer.vue'

export default {
  components: {
    ProductEditor,
    EventViewer
  },
  computed: {
    editMode () {
      return !!this.getId()
    }
  },
  methods: {
    getId () {
      return this.$route.params.id
    }
  }
}
</script>
